import { store, observable, action } from '~/common/mobx.decorator'
import { availableJobStore } from './available.job.store'
import { featuredJobStore } from './featured.job.store'
import { matchesJobStore } from './matches.job.store'

@store()
class JobStore {
	@observable availableJobs = { data: [], total: 0 }
	@observable featuredJobs = { data: [], total: 0 }

	availableJobStore = availableJobStore
	featuredJobStore = featuredJobStore
	matchesJobStore = matchesJobStore

	@action
	fetchJobs = async () => {
		// Fetch jobs from the server
	}

	@action
	setBestMatches = (jobs, total) => {
		this.bestMatches.data = jobs
		this.bestMatches.total = total || jobs.length || 0
	}

	@action
	setFeaturedJobs = (jobs, total) => {
		this.featuredJobs.data = jobs
		this.featuredJobs.total = total || jobs.length || 0
	}

	@action
	fetchDiscovers = async () => {
		// Fetch discovers from the server
	}
}

const jobStore = new JobStore()

export default jobStore
